import { types } from "mobx-state-tree"
import _, { keyBy } from 'lodash'
import User from './models/User'
import Player from './models/Player'
import Template from './models/Template'
import { keys } from 'mobx'


const EntityStore = types.model('EntityStore', {

    user: types.maybe(User),
    players: types.map(Player),
    templates: types.map(Template),

}).actions(self => ({

    push(attr, values) {
        self[attr] = [
            ...self[attr],
            ...values,
        ]
    },

    add(entity, entities, clear = false, identifier = 'id') {
        const identifiers = []

        if (clear) {
            self[entity].clear()
        }

        if (!entities) {
            return []
        }

        self[entity].merge(
            keyBy(entities, e => {
                identifiers.push(e[identifier])

                return e[identifier]
            }),
        )

        return identifiers
    },

    set(attr, value) {
        self[attr] = value
    },

    clear(entity) {
        self[entity].clear()
    },

    remove(entity, key) {
        if (!self[entity]) {
            return false
        }

        if (_.isArray(key)) {
            key.forEach((k) => self[entity].delete(k))
        } else if (_.isFunction(key)) {
            keys(self[entity]).forEach((k) => {
                if (key(self[entity].get(k), k, self[entity])) {
                    self[entity].delete(k)
                }
            })
        } else {
            self[entity].delete(key)
        }
    },

})).views(self => ({

    //

}))

export default EntityStore
